var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" }, [
    _c("div", { staticClass: "ak-panel__header ak-panel__header--small" }, [
      _c("div", { staticClass: "ak-panel__title" }, [
        _c("i", { staticClass: "fa fa-truck" }),
        _vm._v(
          "\n                " +
            _vm._s(_vm.$t("Laatste aanpassing olieprijs")) +
            "\n                "
        ),
        _vm.prices
          ? _c("span", { staticClass: "small" }, [
              _vm._v(
                " - " + _vm._s(_vm._f("date-relative")(_vm.prices.dateAdded))
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ak-panel__body ak-panel__body--small reading" }, [
      _c("div", { staticClass: "ak-data-table__table table-candidates" }, [
        _c(
          "table",
          { staticClass: "ak-table ak-table--compact ak-panel__table" },
          [
            _c("thead", [
              _c("tr", { staticClass: "ak-table-row" }, [
                _c("th", { staticClass: "ak-table-head" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("Aantal liters")))]),
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "ak-table-head" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Mazout (Gasolie Extra) prijs"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "ak-table-head" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Mazout Energy+ (Gasolie Extra Energy+) prijs")
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.prices
              ? _c("tbody", { staticClass: "ak-table-body" }, [
                  _c("tr", { staticClass: "ak-table-row" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("td", { staticClass: "ak-table-column" }, [
                      _c("span", [_vm._v(_vm._s(_vm.prices.price1000))]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "ak-table-column" }, [
                      _c("span", [_vm._v(_vm._s(_vm.prices.price1000plus))]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", { staticClass: "ak-table-row" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("td", { staticClass: "ak-table-column" }, [
                      _c("span", [_vm._v(_vm._s(_vm.prices.price2000))]),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "ak-table-column" }, [
                      _c("span", [_vm._v(_vm._s(_vm.prices.price2000plus))]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "m-t-15" },
          [
            _vm.prices && !_vm.prices.dateApproved
              ? _c("ak-button", { on: { click: _vm.approvePrice } }, [
                  _vm._v(
                    "\n                       " +
                      _vm._s(_vm.$t("Nu goedkeuren")) +
                      "\n                    "
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.prices && _vm.prices.dateApproved
          ? _c("p", [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("Goedgekeurd")) +
                  ": " +
                  _vm._s(_vm._f("date-relative")(_vm.prices.dateApproved)) +
                  " " +
                  _vm._s(_vm.$t("door")) +
                  " " +
                  _vm._s(_vm.administrator.firstName) +
                  " " +
                  _vm._s(_vm.administrator.surname) +
                  "\n                "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "ak-table-column" }, [
      _c("span", [_vm._v("1000")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "ak-table-column" }, [
      _c("span", [_vm._v("2000")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }